// Published personal training rates from named Singapore providers.
//
// WHY THIS FILE EXISTS
// The operators ranking for "personal trainer rates Singapore" are themselves gyms and
// studios, so none of them can publish a comparison naming their rivals. A marketplace
// can. This table is the second reason the rates guide is worth citing.
//
// RULES - these matter more than the table itself:
//  1. `rate` must trace to the provider's own public page (`url`) or a dated written
//     quote. Never an estimate, never a third-party blog's figure.
//  2. Where a provider does not publish rates, set published: false and say so. "Not
//     published" is accurate and useful; a guessed number about a named competitor is
//     the one error here with consequences beyond SEO.
//  3. `verifiedOn` is per row. Re-verify quarterly - a stale named-price table is worse
//     than no table. Update the date only when the figure has actually been re-checked.
//
// Last full sweep: 20 September 2026.

export const ptMarketRatesVerifiedOn = "20 September 2026"

export const ptMarketRates = [
    {
        provider: "LEVEL Singapore",
        url: "https://level.com.sg/rates/",
        format: "Studio, 1-on-1",
        published: true,
        rate: "From $174.40 / session",
        membership: "Not stated",
        note: "Rate is inclusive of GST. First consultation is complimentary. Couple and small-group formats are quoted on enquiry.",
        verifiedOn: "2026-09-20",
    },
    {
        provider: "Catalyst Performance",
        url: "https://catalystperformance.sg/blog/personal-trainer-cost-singapore",
        format: "Studio, 1-on-1",
        published: true,
        rate: "$163.50 first session",
        membership: "Not required",
        note: "Published in the studio's own cost guide as its first-session rate.",
        verifiedOn: "2026-09-20",
    },
    {
        provider: "FITLUC",
        url: "https://www.fitluc.com/how-much-should-i-pay-for-a-personal-trainer/",
        format: "Home and gym, 1-on-1 and buddy",
        published: true,
        rate: "Home from $160 / session; gym trial $50, home trial $90",
        membership: "Not required",
        note: "Buddy trials published at $90 (gym) and $130 (home).",
        verifiedOn: "2026-09-20",
    },
    {
        provider: "ActiveSG",
        url: "https://www.activesgcircle.gov.sg/facilities/individual-rates",
        format: "Public gym venue",
        published: true,
        rate: "$2.50 / entry (venue access only)",
        membership: "ActiveSG membership, free to join",
        note: "ActiveSG prices gym access, not personal training. Independent trainers coach clients at these venues and charge their own rate on top of the entry fee, which is why ActiveSG-based training is consistently the cheapest route in this table.",
        verifiedOn: "2026-09-20",
    },
    {
        provider: "Fitness First",
        url: "https://www.fitnessfirst.com.sg/",
        format: "Commercial gym chain",
        published: false,
        rate: "Not published",
        membership: "Required",
        note: "No standard personal training rate card is published online; rates are quoted in club after an enquiry, and a paid membership is required alongside the training package.",
        verifiedOn: "2026-09-20",
    },
    {
        provider: "Virgin Active",
        url: "https://www.virginactive.com.sg/",
        format: "Commercial gym chain",
        published: false,
        rate: "Not published",
        membership: "Required",
        note: "Personal training rates are not listed publicly and are quoted on enquiry. Third-party blogs quote figures for Virgin Active that we could not verify against the club's own published material, so we do not repeat them here.",
        verifiedOn: "2026-09-20",
    },
    {
        provider: "Anytime Fitness",
        url: "https://www.anytimefitness.sg/",
        format: "Franchised gym chain",
        published: false,
        rate: "Not published",
        membership: "Required",
        note: "Each franchised club sets and quotes its own personal training rate, so there is no single national figure to publish.",
        verifiedOn: "2026-09-20",
    },
    {
        provider: "The PIT Personal Training",
        url: "https://www.pitpersonaltrainer.com.sg/blog/category/blog/personal-training-rates-singapore-2026",
        format: "Studio",
        published: false,
        rate: "Not published",
        membership: "Not stated",
        note: "Publishes market category ranges ($60-$100 condo and park, $90-$130 gym chains, $130-$200+ private studios) rather than its own rate card.",
        verifiedOn: "2026-09-20",
    },
]
